import React from "react";

const iconPaths = {
  dashboard: "M3 3h8v8H3zM13 3h8v5h-8zM13 10h8v11h-8zM3 13h8v8H3z",
  students: "M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm8 0a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 21a6 6 0 0 1 12 0M10 21a6 6 0 0 1 12 0",
  teachers: "M6 10a3 3 0 1 0 0-6 3 3 0 0 0 0 6Zm12 1a3 3 0 1 0 0-6 3 3 0 0 0 0 6ZM2 21a6 6 0 0 1 9-5.2M13 21a6 6 0 0 1 9-5",
  account: "M12 3v18M3 12h18",
  list: "M5 6h14M5 12h14M5 18h14",
  assignment: "M8 4h8M8 8h8M8 12h5M4 4h1M4 8h1M4 12h1M6 20h12a2 2 0 0 0 2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2Z",
  notice: "M12 3a7 7 0 0 0-7 7v4l-2 3h18l-2-3v-4a7 7 0 0 0-7-7ZM10 21h4",
  eye: "M2 12s3.5-6 10-6 10 6 10 6-3.5 6-10 6-10-6-10-6Zm10 3a3 3 0 1 0 0-6 3 3 0 0 0 0 6Z",
  eyeOff: "M3 3l18 18M10.6 6.3A10.9 10.9 0 0 1 12 6c6.5 0 10 6 10 6a17 17 0 0 1-4.1 4.6M8.6 8.6A4 4 0 0 0 8 10.7M12.1 16a4 4 0 0 1-3.8-5.2M1.9 12S5.4 6 12 6",
  revenue: "M4 17l4-5 4 3 6-8M18 7h0",
  logout: "M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4M10 17l5-5-5-5M15 12H3",
  fee: "M3 7h18v10H3zM7 11h10",
  transport: "M3 13h2l2-5h10l2 5h2M7 18a2 2 0 1 0 0-4 2 2 0 0 0 0 4Zm10 0a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
  history: "M12 8v5l3 2M12 3a9 9 0 1 0 9 9",
  child: "M12 11a4 4 0 1 0 0-8 4 4 0 0 0 0 8ZM4 21a8 8 0 0 1 16 0",
  edit: "M4 20h4l10-10-4-4L4 16v4ZM12 6l4 4",
  trash: "M4 7h16M9 7V4h6v3M8 7l1 13h6l1-13",
  check: "M5 12l4 4 10-10",
  close: "M6 6L18 18M18 6L6 18",
  search: "M11 19a8 8 0 1 1 5.3-14 8 8 0 0 1-5.3 14Zm10 2-4.2-4.2",
  chevronRight: "M9 6l6 6-6 6",
  copy: "M9 9h10v12H9zM5 3h10v4"
};

export default function AppIcon({ name = "list", size = 14, className = "" }) {
  const d = iconPaths[name] || iconPaths.list;
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden="true"
    >
      <path d={d} stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
